import React from 'react'
import classnames from 'classnames'

import * as layoutStyles from '../layout/layout.styles'
import { Column } from '../layout/Column.react'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError () {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch (error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo)
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>
    }

    return this.props.children
  }
}

export const ColumnContent = ({ result, width = 20, contentFunction = () => {}, extraClassNames, ...columnProps }) =>
  <ErrorBoundary>
    <Column width={width} tableContentColumn inset insetBreak role='cell' data-testid='ColumnContent' {...columnProps}>
      <span
        className={classnames(layoutStyles.header, { [extraClassNames]: !!extraClassNames })}
      >
        {contentFunction(result)}
      </span>
    </Column>
  </ErrorBoundary>
